import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
});
